/* eslint-disable max-lines-per-function */
// i18next-extract-mark-ns-start LaRubrique
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useTranslation } from 'gatsby-plugin-react-i18next';
import { graphql } from 'gatsby';
import { Container, Content as StyledContent } from '../components/home/homeStyledComponents';
import { contentWidth, margins, tabletThresholdPixels } from '../components/home/v4/styledComponents';
import MenuBar from '../components/home/MenuBar';
import LaRubriqueHeader from '../components/LaRubrique/LaRubriqueHeader';
import Pagination from '../components/LaRubrique/Pagination';
import Footer from '../components/home/v3/Footer';
import Layout from '../layouts/index';
import routesMap from '../Routes';
import BlogNavbar from '../components/LaRubrique/BlogNavbar';
import BlogVerticalNavbar from '../components/LaRubrique/BlogVerticalNavbar';
import { getDateSincePost } from '../components/LaRubrique/listPostInfos';
import BlogPostCard from '../components/LaRubrique/BlogPostCard';

const Content = styled(StyledContent)`
  margin-bottom: ${margins.xl};

  @media (max-width: ${tabletThresholdPixels}) {
    padding: 0px 22px;
    box-sizing: border-box;
  }
`;

const SubContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: auto;
  width: ${contentWidth - 296}px;
  margin-bottom: 64px;

  @media (max-width: ${tabletThresholdPixels}) {
    width: unset;
  }
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  width: 1040px;
  margin: 0 auto 64px;
  @media (max-width: ${tabletThresholdPixels}) {
    flex-direction: column;
    gap: 32px;
    width: 100%;
  }
  `;

const GridPosts = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 60px;
  width: 100%;
  max-width: 700px;
  @media (max-width: ${tabletThresholdPixels}) {
    grid-template-columns: 1fr;
    grid-gap: 40px;
  }
  `;

const NoArticleMessage = styled.div`
  font-size: 24px;
  line-height: 32px;
  font-family: 'Space Mono', monospace;
  text-align: center;
  margin: 0 auto;
  width: 100%;
  max-width: 700px;
  grid-column: 1/3;
  @media (max-width: ${tabletThresholdPixels}) {
    grid-column: 1;
    font-size: 16px;
  }
  `;
function CategoryArticlesTemplate({ pageContext }) {
  const {
    posts, category, pageCount, mainCategory, mainCategories, activePage, subCategory, item,
  } = pageContext;
  const { t } = useTranslation();

  const getLink = (index) => {
    if (item) return routesMap.getCategoryArticlePageUrl(`${mainCategory.slug + category.slug + subCategory.slug + item.slug}`, index);
    if (category) return routesMap.getCategoryArticlePageUrl(`${mainCategory.slug + category.slug}`, index);
    return `${mainCategory.path}${index}`;
  };

  const formattedPosts = posts.map((post) => ({
    id: post.slug,
    title: post.mainTitle,
    image: post.listImage.publicURL,
    imageAlt: post.listImageAlt,
    text: post.introduction,
    service: post.category,
    delay: `${t('Posté il y a')} ${getDateSincePost(t, post.datePublished)}`,
    preFilledSteps: {
      selectedCategory: post.mainCategory,
    },
    path: post.path,
  }));

  return (
    <Layout
      routeSlug={(category?.slug) ? `LaRubriqueCategory_${(mainCategory.slug || '') + category.slug}` : 'LaRubrique'}
      routeUrl={(category?.slug)
        ? routesMap.getCategoryArticlePageUrl(`${(mainCategory.slug || '') + category.slug}`, activePage)
        : routesMap.getCategoryArticlePageUrl(`${(mainCategory.slug || '')}`, activePage)}
    >
      <Container>
        <MenuBar />
        <LaRubriqueHeader />
        <Content>
          <BlogNavbar mainCategories={mainCategories} mainCategory={mainCategory} />
          <MainContent>
            <BlogVerticalNavbar mainCategory={mainCategory} category={category} subCategoryItem={item} />
            <GridPosts>
              {formattedPosts.length > 0 ? formattedPosts.map((post) => (
                <BlogPostCard data={post} key={post.id} />
              ))
                : (
                  <NoArticleMessage>
                    {t('Oups, il n\'y a pas encore d\'article dans cette catégorie, nos experts sont sur le coup pour vous prodiguer leurs meilleurs conseils !')}
                  </NoArticleMessage>
                )}
            </GridPosts>
          </MainContent>
          <SubContainer>
            <Pagination activePage={activePage} pageCount={pageCount} getLink={getLink} />
          </SubContainer>
        </Content>
        <Footer />
      </Container>
    </Layout>
  );
}

CategoryArticlesTemplate.propTypes = {
  pageContext: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    category: PropTypes.shape({
      slug: PropTypes.string,
    }),
    categories: PropTypes.arrayOf(PropTypes.shape({})),
    mainCategory: PropTypes.shape({
      slug: PropTypes.string,
      categories: PropTypes.arrayOf(PropTypes.shape({})),
      path: PropTypes.string,
    }).isRequired,
    mainCategories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    pageCount: PropTypes.number.isRequired,
    activePage: PropTypes.number.isRequired,
    subCategory: PropTypes.shape({
      slug: PropTypes.string,
    }),
    item: PropTypes.shape({
      slug: PropTypes.string,
    }),
  }).isRequired,
};

export default CategoryArticlesTemplate;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: { language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
